import { ContentContext, CountryContext, LocaleContext } from 'Components/hooks/context';
import React, { useContext } from 'react';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import SmartText from '@reuters-graphics/react-smart-text';
import last from 'lodash/last';

const atlas = new AtlasMetadataClient();

const Text = (props) => {
  const { vaccinationData } = props;

  const content = useContext(ContentContext);
  const countrySlug = useContext(CountryContext);
  const locale = useContext(LocaleContext);

  if (!vaccinationData) return null;

  const country = atlas.getCountry(countrySlug);

  const population = country.dataProfile.population.d;
  const lastWeekData = vaccinationData.dailyDoses.slice(-7);

  const avgDailyInLastWeek = lastWeekData.reduce((a, d) => a + d.count, 0) / lastWeekData.length;
  const daysForNextTenPercentPop = (population * 2 * 0.1) / avgDailyInLastWeek;

  if (!avgDailyInLastWeek || vaccinationData.dailyDoses.length < 7) return null;

  return (
    <SmartText
      source={content.template.vaccination.rate}
      context={{
        country: atlas.getCountry(countrySlug).translations[locale],
        avg: Math.round(avgDailyInLastWeek).toLocaleString(locale),
        days: Math.ceil(daysForNextTenPercentPop).toLocaleString(locale),
      }}
      wrap
    />
  );
};

export default Text;
